import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from "@/reportWebVitals";
import ErrorBoundary from "@shared/errorBoundary/ErrorBoundary";
import App from "@/App";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "@store/store";

const Loader = () => (
  <div className="flex h-screen items-center justify-center">
    <span className="text-sm text-gray-500">Loading...</span>
  </div>
);

const Root: React.FC = (props) => {
  return (
    <>
      <ErrorBoundary>
        <Provider store={store}>
          <PersistGate loading={<Loader />} persistor={persistor}>
            <BrowserRouter basename={import.meta.env.BASE_URL}>
              <App {...props} />
            </BrowserRouter>
          </PersistGate>
        </Provider>
      </ErrorBoundary>
    </>
  );
};
reportWebVitals();

export default Root;
